import { render } from "./ReviewForm.vue?vue&type=template&id=9c8bc818&scoped=true"
import script from "./ReviewForm.vue?vue&type=script&lang=js"
export * from "./ReviewForm.vue?vue&type=script&lang=js"

import "./ReviewForm.vue?vue&type=style&index=0&id=9c8bc818&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c8bc818"]])

export default __exports__